const smartViewTexts = {
    dateFilter: {
        comparedToLastPeriod: gettext('Compared to last period'),
        comparedToLastYear: gettext('Compared to last year'),
    },
    deleterTaggedGroupModal: {
        label: gettext('Delete Group'),
        subtitle: gettext('This action can\'t be undone. Are you sure ?'),
        title: gettext('Delete Group'),
        deleteSuccessful: gettext('Group deleted!'),
        deleteError: gettext('Could not delete the Group!'),
    },
    forecast: {
        titleForecast: gettext('Monitor your key metrics and use the monthly forecast value to keep track of your goals.'),
    },
    overviewTable: {
        subtitleDashboard: gettext('Monitor your key metrics and keep track of your goals.'),
        titleDashboard: gettext('Overview'),
    },
    campaignTable: {
        metrics: gettext('Metrics'),
        campaignType: gettext('Campaign Type'),
        metricsPlaceholder: gettext('Metrics'),
        name: gettext('Name'),
        status: gettext('Status'),
        budget: gettext('Daily Budget'),
        searchInput: gettext('Search...'),
        subtitleDashboard: gettext('A deep dive view of your campaigns.'),
        title: gettext('This month prediction by campaign'),
        titleDashboard: gettext('Campaigns and Groups'),
        totalAccount: gettext('Total'),
        selectTitle: gettext('Select any metric'),
        tag: gettext('Tags'),
    },
    tagsGroup: {
        createNewGroup: gettext('Add Segment'),
        groupBy: gettext('Segments'),
        placeholder: gettext('Select a Group'),
        subtitle: gettext('In order to group your data, you need to tag your campaigns first.'),
        deleteMessage: {
            success: gettext('Group Deleted!'),
            error: gettext('An error occurred while trying to delete the group!'),
        },
        tag: gettext('Tag'),
    },
    segmentedGraphSelector: {
        placeholder: gettext('Metrics'),
        subMenuTitle: gettext('Compared to'),
    },
    hotSpotList: {
        searchInput: gettext('Search...'),
    },
    hotSpotHistoryTable: {
        subtitleDashboard: gettext('All your hotspots over selected period'),
        titleDashboard: gettext('HotSpot History'),
    },
    hotSpotModal: {
        categoryError: gettext('You must select at least one category'),
        categoryLabel: gettext('Category'),
        categoryPlaceholder: gettext('Choose or create one…'),
        createLabel: gettext('Create HotSpot'),
        descriptionPlaceholder: gettext('Write a description…'),
        endDateError: gettext('End date cannot be before start date'),
        endDateLabel: gettext('End Date'),
        endDatePlaceholder: gettext('Pick a date'),
        nameError: gettext('Name cannot be empty'),
        nameLabel: gettext('Hotspot Name'),
        namePlaceholder: gettext('Write a name…'),
        startDateError: gettext('Start date cannot be after end date'),
        startDateLabel: gettext('Start Date'),
        startDatePlaceholder: gettext('Pick a date'),
        descriptionLabel: gettext('Description'),
        saveLabel: gettext('Save HotSpot'),
    },
    hotSpotTable: {
        categories: gettext('Categories'),
        endDate: gettext('End Date'),
        startDate: gettext('Start Date'),
        title: gettext('Title'),
        selectCategory: gettext('Select categories'),
        selectedCategory: gettext('category selected'),
        selectedCategories: gettext('categories selected'),
        subtitleDashboard: gettext('Add hotspots to your chart so you can correlate your metrics '
            + 'to any event you want. We really recommend you to use it.'),
        titleDashboard: gettext('Add a Hotspot to a Special Date'),
    },
    deleterHotSpotModal: {
        label: gettext('Delete HotSpot'),
        subtitle: gettext('This action can\'t be undone. Are you sure ?'),
        title: gettext('Delete HotSpot'),
        deleteSuccessful: gettext('HotSpot deleted!'),
        deleteError: gettext('Could not delete the HotSpot!'),
    },
    tagsGroupModal: {
        button: gettext('TagsGroup'),
        label: gettext(''),
        createLabel: gettext('Add Tags'),
        saveLabel: gettext('Save Tags'),
        headerLabel: gettext('This is where you set up your Omnichannel Budget Manager. Select the campaigns you want to group together and let Tess take care of your monthly PPC budget. We strongly recommend to only select campaigns with the same objective to each cluster. Keep in mind that lifetime budget and shared budget campaigns are not eligible for OBM, as are Google Express campaigns.'),
        facebookAdSetLabel: gettext('Facebook Ad Set Tag Level '),
        gaugeLabel: gettext('Campaigns and Ad Sets Tagged '),
        tagsPlaceHolder: gettext('Edit here...'),
        inputNameGroupPlaceholder: gettext('Type here the group name...'),
    },
    segmentedGraphTitle: {
        HourOfDay: gettext('This hour'),
        Date: gettext('Today'),
        Week: gettext('This week'),
        Month: gettext('This month'),
        Quarter: gettext('This quarter'),
        Previous: gettext('Previous Period'),
        DateTitle: gettext('Date'),
    },
    segmentedGraphFeatures: {
        download: gettext('Download'),
    },
};

export const widgetsTexts = {
    estimateBox: {
        currentMonthGoalText: gettext('Compared to previous period'),
        lastYearGoalText: gettext('Compared to last year'),
        oldGoalText: gettext('Average of Last 3 Months:'),
    },
    subtitle: gettext('This Month'),
    boxSubtitle: {
        gaugeSubtitle: gettext('Average of Last 3 Months'),
        goalSubtitle: gettext('Set Goal (coming soon)'),
    },
    gaugeRange: {
        below75: gettext('Below 75%'),
        between75_100: gettext('Between 75% - 100%'),
        above100: gettext('Above 100%'),
    },
};

export default smartViewTexts;
